// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Checkbox-module__root___TWHx9{border-radius:6px}", "",{"version":3,"sources":["webpack://./src/redesign/components/Checkbox/Checkbox.module.scss"],"names":[],"mappings":"AAAA,+BACE,iBAAA","sourcesContent":[".root {\n  border-radius: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "Checkbox-module__root___TWHx9"
};
export default ___CSS_LOADER_EXPORT___;
